function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin } from 'oskari-ui/util';
var ViewHandler = /*#__PURE__*/function (_StateHandler) {
  function ViewHandler(instance) {
    var _this;
    _classCallCheck(this, ViewHandler);
    _this = _callSuper(this, ViewHandler);
    _this.instance = instance;
    _this.sandbox = instance.getSandbox();
    _this.state = {
      layers: _this._getLayers()
    };
    return _this;
  }
  _inherits(ViewHandler, _StateHandler);
  return _createClass(ViewHandler, [{
    key: "_getLayers",
    value: function _getLayers() {
      return _toConsumableArray(this.sandbox.findAllSelectedMapLayers()).reverse();
    }
  }, {
    key: "updateLayers",
    value: function updateLayers() {
      this.updateState({
        layers: this._getLayers()
      });
    }
  }, {
    key: "updateVisibilityInfo",
    value: function updateVisibilityInfo(event) {
      // trigger change
      this.updateState({});
    }
  }, {
    key: "reorderLayers",
    value: function reorderLayers(fromPosition, toPosition) {
      if (isNaN(fromPosition)) {
        throw new Error('reorderLayers: fromPosition is Not a Number: ' + fromPosition);
      }
      if (isNaN(toPosition)) {
        throw new Error('reorderLayers: toPosition is Not a Number: ' + toPosition);
      }
      if (fromPosition === toPosition) {
        // Layer wasn't actually moved, ignore
        return;
      }
      var layers = _toConsumableArray(this.state.layers);
      if (fromPosition >= layers.length) {
        return;
      }
      if (toPosition >= layers.length) {
        return;
      }
      var layer = layers.splice(fromPosition, 1)[0];
      layers.splice(toPosition, 0, layer);
      this.updateState({
        layers: layers
      });

      // the layer order is reversed in presentation
      // the lowest layer has the highest index
      var toDataPosition = layers.length - 1 - toPosition;
      this.sandbox.postRequestByName('RearrangeSelectedMapLayerRequest', [layer.getId(), toDataPosition]);
    }
  }, {
    key: "toggleLayerVisibility",
    value: function toggleLayerVisibility(layer) {
      var visibility = layer.isVisible();
      this.sandbox.postRequestByName('MapModulePlugin.MapLayerVisibilityRequest', [layer.getId(), !visibility]);
    }
  }, {
    key: "changeOpacity",
    value: function changeOpacity(layer, opacity) {
      if (opacity === '') {
        opacity = 0;
      }
      this.sandbox.postRequestByName('ChangeMapLayerOpacityRequest', [layer.getId(), opacity]);
    }
  }, {
    key: "removeLayer",
    value: function removeLayer(layer) {
      this.sandbox.postRequestByName('RemoveMapLayerRequest', [layer.getId()]);
    }
  }, {
    key: "changeLayerStyle",
    value: function changeLayerStyle(layer, styleName) {
      this.sandbox.postRequestByName('ChangeMapLayerStyleRequest', [layer.getId(), styleName]);
    }
  }, {
    key: "locateLayer",
    value: function locateLayer(layer, zoomToExtent) {
      this.sandbox.postRequestByName('MapModulePlugin.MapMoveByLayerContentRequest', [layer.getId(), zoomToExtent]);
    }
  }]);
}(StateHandler);
export var SelectedLayersHandler = controllerMixin(ViewHandler, ['reorderLayers', 'removeLayer', 'changeOpacity', 'toggleLayerVisibility', 'changeLayerStyle', 'locateLayer']);